(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ClearableInput", [], factory);
	else if(typeof exports === 'object')
		exports["ClearableInput"] = factory();
	else
		root["ClearableInput"] = factory();
})(window, function() {
return 